import { AlertTriangle, Lock } from 'lucide-react';
import type { PlanCardSummary } from '@/types';
import { ChannelBadge } from '@/components/changes/badges';

/** The drafted plan under a reply (D11): its steps, each with its channel and what it still needs. */
export function PlanCard({ plan }: { plan: PlanCardSummary }) {
  return (
    <div className="mb-3 rounded-lg border border-border bg-secondary/30 p-3">
      <div className="mb-2 flex items-center justify-between text-xs font-medium uppercase tracking-wide text-muted-foreground">
        <span>Plan · {plan.title}</span>
        <span className="normal-case tracking-normal">v{plan.version}</span>
      </div>
      <ol className="space-y-1.5">
        {plan.steps.map((step, i) => (
          <li key={step.key} className="flex items-start gap-2 text-sm">
            <span className="w-4 shrink-0 text-muted-foreground">{i + 1}.</span>
            <ChannelBadge channel={step.channel} className="mt-0.5 shrink-0" />
            <span className="min-w-0 flex-1 text-foreground">{step.title}</span>
            {step.missingInputs.length > 0 && (
              <span className="inline-flex shrink-0 items-center gap-1 text-xs text-amber-400" title={`needs ${step.missingInputs.join(', ')}`}>
                <AlertTriangle className="h-3.5 w-3.5" /> needs {step.missingInputs.join(', ')}
              </span>
            )}
            {step.missingScopes.length > 0 && (
              <span className="inline-flex shrink-0 items-center gap-1 text-xs text-amber-400" title={step.missingScopes.join(', ')}>
                <Lock className="h-3.5 w-3.5" /> scope
              </span>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}
